// ✅ adminEmails.js
const ADMIN_EMAILS = [
  "rajk4435689@admin.com",
  "second.admin@gmail.com",
  "third.admin@gmail.com"
];

export default ADMIN_EMAILS; // ✅ default export
